import {
  setActiveTournamentAction,
  setAllUsers,
  setTournamentsAction,
  updateActiveTournamentAction,
  updateAvailableSteps,
} from "./competitionSlice";
import { notifyMessage } from "../../services/toasterServices";
import { logoutUser, setLoading } from "../user/userSlice";
import { updateCourses } from "../course/courseSlice";
import * as CompetitionServices from "./competitionServices";
import * as CoursesServices from "../course/courseServices";
// import { activeTournamentSelector } from "./competitionSelectors";
// import { set } from "lodash";
import { prepareFormData } from "services/competitionServices";
import { setTeesets } from "./competitionSlice";
// import useLocalStorageService from './useLocalStorageService.js';
// import { useSelector } from "react-redux";

const getJWTToken = getState => {
  try {
    const state = getState();
    return state.user.tokens.jwtToken;
  } catch (error) {
    notifyMessage("error", error.message, 5000, "colored", "top-center");
  }
};

export const saveAndUpdate =
  ({ id, tab, schema }) =>
  async dispatch => {
    // await dispatch(updateAvailableSteps(tab));
    // await dispatch(updateAvailableSteps(tab));
    // await dispatch(updateActiveTournamentAction({ id, schema }));
    console.log(id, schema, tab);
    switch (tab) {
      case "basicInfo":
        if (id === -1) {
          await dispatch(createNewCompetition(tab, schema.basicInfo));
        } else {
          await dispatch(updateBasicInfo(id, tab, schema.basicInfo));
        }
        break;
      case "regPaymentInfo":
        await dispatch(updateRegPaymentInfo(id, tab, schema.regPaymentInfo));
        break;
      case "colorTheme":
        await dispatch(updateColorTheme(id, tab, schema.colorTheme));
        break;
      case "courses":
        await dispatch(updateCourse(id, tab, schema.courses));
        break;
      // case "rounds":
      //   await dispatch(updateRounds(id, tab, schema.rounds));
      //   break;
      case "divisions":
        await dispatch(updateDivisions(id, tab, schema.divisions));
        break;
      default:
        console.log("Unknown tab");
        break;
    }

    // return await dispatch(updateActiveTournamentAction({ id, schema }));
  };

export const createNewCompetition = (tab, basicInfoSchema) => {
  return async (dispatch, getState) => {
    dispatch(setLoading(true));
    try {
      const state = getState();
      const token = state.user.tokens.jwtToken;

      //making the formdata to be sent to the backend
      const basicInfoFormData = prepareFormData(basicInfoSchema);

      // const { setDataInLocalStorage } = useLocalStorageService();
      const response = await CompetitionServices.createCompetition(basicInfoFormData, token);
      if (response.status === 200) {
        notifyMessage("success", "Information Saved!", 5000, "colored", "top-center");
        // update state
        // save on redux state only when it saves on the database successfully
        let competitionId = response.data.competitionId;
        // await dispatch(setActiveTournamentAction(tournament));
        await dispatch(updateAvailableSteps(tab));
        await dispatch(updateActiveTournamentAction({ id: competitionId, schema: { basicInfo: basicInfoSchema } }));
        // setDataInLocalStorage(competitionId, basicInfoSchema);
        // navigate(-1);
      } else if (response.status === 401) {
        const responseMessage = `Please Login Again! \n ${response.data.message ? response.data.message : ""}`;
        notifyMessage("error", responseMessage, 5000, "colored", "top-center");
        dispatch(logoutUser());
        // navigate("/login");
      } else {
        const errorMessage = `Failed to save Info! \n ${response.data.message ? response.data.message : ""}`;
        throw new Error(errorMessage);
      }
    } catch (err) {
      notifyMessage("error", err.message, 5000, "colored", "top-center");
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const updateBasicInfo = (id, tab, basicInfoSchema) => {
  return async (dispatch, getState) => {
    dispatch(setLoading(true));
    try {
      const state = getState();
      // const directorId = state.user.user._id;
      const token = state.user.tokens.jwtToken;
      // const userId = state.user.user._id;
      const competitionId = id;
      //making the formdata to be sent to the backend
      const basicInfoFormData = prepareFormData(basicInfoSchema, competitionId);
      console.log(basicInfoFormData);
      // Object.assign(course, { editors: { courseOwner: userId, courseEditors: [] } });
      // Object.keys(course).forEach((key) => {
      //   if (course[key] === undefined) {
      //     course[key] = null;
      //   }
      // });
      // const { setDataInLocalStorage } = useLocalStorageService();
      const response = await CompetitionServices.saveBasicInfo(competitionId, basicInfoFormData, token);
      if (response.status === 200) {
        notifyMessage("success", "Information Saved!", 5000, "colored", "top-center");
        // update state
        // save on redux state only when it saves on the database successfully
        await dispatch(updateAvailableSteps(tab));
        await dispatch(updateActiveTournamentAction({ _id: competitionId, schema: { basicInfo: basicInfoSchema } }));
        // setDataInLocalStorage(competitionId, basicInfoSchema);
        // setDataInLocalStorage
        // navigate(-1);
      } else if (response.status === 401) {
        const responseMessage = `Please Login Again! \n ${response.data.message ? response.data.message : ""}`;
        notifyMessage("error", responseMessage, 5000, "colored", "top-center");
        dispatch(logoutUser());
        // navigate("/login");
      } else {
        const errorMessage = `Failed to save Info! \n ${response.data.message ? response.data.message : ""}`;
        throw new Error(errorMessage);
      }
    } catch (err) {
      notifyMessage("error", err.message, 5000, "colored", "top-center");
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const updateRegPaymentInfo = (id, tab, regPaymentInfoSchema) => {
  return async (dispatch, getState) => {
    dispatch(setLoading(true));
    try {
      const state = getState();
      // const directorId = state.user.user._id;
      const token = state.user.tokens.jwtToken;
      // const userId = state.user.user._id;
      const competitionId = id;
      // const regPaymentFormData = prepareFormData(regPaymentInfoSchema, competitionId);
      // console.log(regPaymentFormData);
      const response = await CompetitionServices.saveRegPaymentInfo(
        competitionId,
        JSON.stringify(regPaymentInfoSchema),
        token,
      );
      if (response.status === 200) {
        notifyMessage("success", "Information Saved!", 5000, "colored", "top-center");
        // update state
        // save on redux state only when it saves on the database successfully
        await dispatch(updateAvailableSteps(tab));
        await dispatch(
          updateActiveTournamentAction({ _id: competitionId, schema: { regPaymentInfo: regPaymentInfoSchema } }),
        );
        // setDataInLocalStorage(competitionId, basicInfoSchema);
        // setDataInLocalStorage
        // navigate(-1);
      } else if (response.status === 401) {
        const responseMessage = `Please Login Again! \n ${response.data.message ? response.data.message : ""}`;
        notifyMessage("error", responseMessage, 5000, "colored", "top-center");
        dispatch(logoutUser());
        // navigate("/login");
      } else {
        const errorMessage = `Failed to save Info! \n ${response.data.message ? response.data.message : ""}`;
        throw new Error(errorMessage);
      }
    } catch (err) {
      notifyMessage("error", err.message, 5000, "colored", "top-center");
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const updateColorTheme = (id, tab, colorThemeSchema) => {
  return async (dispatch, getState) => {
    dispatch(setLoading(true));
    try {
      const state = getState();
      // const directorId = state.user.user._id;
      const token = state.user.tokens.jwtToken;
      // const userId = state.user.user._id;
      const competitionId = id;
      // const regPaymentFormData = prepareFormData(regPaymentInfoSchema, competitionId);
      // console.log(regPaymentFormData);
      const response = await CompetitionServices.saveColorThemeInfo(
        competitionId,
        JSON.stringify(colorThemeSchema),
        token,
      );
      if (response.status === 200) {
        notifyMessage("success", "Information Saved!", 5000, "colored", "top-center");
        // update state
        // save on redux state only when it saves on the database successfully
        await dispatch(updateAvailableSteps(tab));
        await dispatch(updateActiveTournamentAction({ _id: competitionId, schema: { colorTheme: colorThemeSchema } }));
        // setDataInLocalStorage(competitionId, basicInfoSchema);
        // setDataInLocalStorage
        // navigate(-1);
      } else if (response.status === 401) {
        const responseMessage = `Please Login Again! \n ${response.data.message ? response.data.message : ""}`;
        notifyMessage("error", responseMessage, 5000, "colored", "top-center");
        dispatch(logoutUser());
        // navigate("/login");
      } else {
        const errorMessage = `Failed to save Info! \n ${response.data.message ? response.data.message : ""}`;
        throw new Error(errorMessage);
      }
    } catch (err) {
      notifyMessage("error", err.message, 5000, "colored", "top-center");
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const updateCourse = (id, tab, coursesSchema) => {
  return async (dispatch, getState) => {
    dispatch(setLoading(true));
    try {
      const state = getState();
      // const directorId = state.user.user._id;
      const token = state.user.tokens.jwtToken;
      // const userId = state.user.user._id;
      const competitionId = id;
      // const regPaymentFormData = prepareFormData(regPaymentInfoSchema, competitionId);
      // console.log(regPaymentFormData);
      const response = await CompetitionServices.saveCoursesInfo(
        competitionId,
        JSON.stringify(coursesSchema.courseInfo),
        token,
      );
      if (response.status === 200) {
        notifyMessage("success", "Information Saved!", 5000, "colored", "top-center");
        // update state
        // save on redux state only when it saves on the database successfully
        await dispatch(updateAvailableSteps(tab));
        await dispatch(updateActiveTournamentAction({ _id: competitionId, schema: { courses: coursesSchema } }));
      } else if (response.status === 401) {
        const responseMessage = `Please Login Again! \n ${response.data.message ? response.data.message : ""}`;
        notifyMessage("error", responseMessage, 5000, "colored", "top-center");
        dispatch(logoutUser());
        // navigate("/login");
      } else {
        const errorMessage = `Failed to save Info! \n ${response.data.message ? response.data.message : ""}`;
        throw new Error(errorMessage);
      }
    } catch (err) {
      notifyMessage("error", err.message, 5000, "colored", "top-center");
    } finally {
      dispatch(setLoading(false));
    }
  };
};

// export const updateRounds = (id, tab, roundsSchema) => {
//   console.log("dateriound", id, tab, roundsSchema);
//   return async (dispatch, getState) => {
//     dispatch(setLoading(true));
//     try {
//       const state = getState();
//       const token = state.user.tokens.jwtToken;
//       const competitionId = id;

//       const response = await CompetitionServices.saveRoundsInfo(
//         competitionId,
//         JSON.stringify(roundsSchema.roundsInfo),
//         token
//       );
//       if (response.status === 200) {
//         notifyMessage("success", "Information Saved!", 5000, "colored", "top-center");
//         // update state
//         // save on redux state only when it saves on the database successfully
//         await dispatch(updateAvailableSteps(tab));
//         await dispatch(updateActiveTournamentAction({ _id: competitionId, schema: { rounds: roundsSchema } }));
//       } else if (response.status === 401) {
//         const responseMessage = `Please Login Again! \n ${response.data.message ? response.data.message : ""}`;
//         notifyMessage("error", responseMessage, 5000, "colored", "top-center");
//         dispatch(logoutUser());
//       } else {
//         const errorMessage = `Failed to save Info! \n ${response.data.message ? response.data.message : ""}`;
//         throw new Error(errorMessage);
//       }
//     } catch (err) {
//       notifyMessage("error", err.message, 5000, "colored", "top-center");
//     } finally {
//       dispatch(setLoading(false));
//     }
//   };
// };

export const updateDivisions = (id, tab, divisionSchema) => {
  return async (dispatch, getState) => {
    dispatch(setLoading(true));
    try {
      const state = getState();
      const token = state.user.tokens.jwtToken;
      const competitionId = id;

      // Get either the new divisions or keep existing ones from active tournament
      const divisionsToSave = divisionSchema?.divisionsInfo || state.competitions.activeTournament?.divisions || [];

      const processedDivisions = divisionsToSave.map(division => {
        const divisionClientId = division.clientId || division.id || CompetitionServices.uuidv4();
        const processedRounds = (division.rounds || []).map(round => {
          return {
            ...round,
            clientId: round.clientId || round.id || CompetitionServices.uuidv4(),
          };
        });

        return {
          ...division,
          clientId: divisionClientId,
          rounds: processedRounds,
        };
      });

      const response = await CompetitionServices.saveDivisionsInfo(
        competitionId,
        JSON.stringify(processedDivisions),
        token,
      );

      if (response.status === 200) {
        notifyMessage("success", "Information Saved!", 5000, "colored", "top-center");
        // update state
        // save on redux state only when it saves on the database successfully
        await dispatch(updateAvailableSteps(tab));

        await dispatch(
          updateActiveTournamentAction({
            _id: competitionId,
            schema: { divisions: processedDivisions },
          }),
        );
      } else if (response.status === 401) {
        const responseMessage = `Please Login Again! \n ${response.data.message ? response.data.message : ""}`;
        notifyMessage("error", responseMessage, 5000, "colored", "top-center");
        dispatch(logoutUser());
      } else {
        const errorMessage = `Failed to save Info! \n ${response.data.message ? response.data.message : ""}`;
        throw new Error(errorMessage);
      }
    } catch (err) {
      notifyMessage("error", err.message, 5000, "colored", "top-center");
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const registerPlayerForTournament = (
  competitionId,
  divisionId,
  swagSize,
  golfScore,
  runningTime,
  playerName,
  divisionName,
  paymentIntentId = null,
  totalFeesPaid = null,
  homeCountry = null,
) => {
  return async (dispatch, getState) => {
    dispatch(setLoading(true));
    try {
      const state = getState();
      const token = state.user.tokens.jwtToken;
      const user = state.user.user;
      if (!user?._id) {
        throw new Error("User not found");
      }

      const selectedDivision = state.competitions.activeTournament.divisions.find(div => div._id === divisionId);
      const tournament = state.competitions.activeTournament;

      let totalFeesPaid = null;
      let processingFee = 0;
      let flatFee = 0;

      if (selectedDivision && tournament.regPaymentInfo.payThroughApp) {
        const entryFee = selectedDivision.entryFee || 0;
        const processingPercent = tournament.regPaymentInfo.processingPercent || 0;
        const flatTransactionFee = tournament.regPaymentInfo.processingFee || 0;

        processingFee = (entryFee * processingPercent) / 100;
        flatFee = flatTransactionFee;
        totalFeesPaid = entryFee + processingFee + flatFee;
      }

      const playerData = {
        userId: user._id,
        division: divisionId,
        swagSize: swagSize || null,
        billingEmail: user.accountInfo.email,
        paymentIntentId,
        avgGolfScore: parseInt(golfScore),
        fiveKRunningTime: parseInt(runningTime),
        playerName,
        divisionName,
        totalFeesPaid,
        processingFee,
        flatFee,
        homeCountry: homeCountry || user.personalInfo.homeCountry || null,
        homeTown: user.personalInfo.hometown || null,
        profilePic: user.personalInfo.profilePic || null,
        homeState: user.personalInfo.homeState || null,
        gender: user.personalInfo.parGender || null,
      };
      const response = await CompetitionServices.registerPlayerToTournament(competitionId, playerData, token);
      if (response.status === 200) {
        notifyMessage("success", "Successfully registered for tournament!", 5000, "colored", "top-center");
        if (response.data) {
          dispatch(setActiveTournamentAction(response.data));
        }
        return true;
      } else {
        throw new Error(response.data?.message || "Failed to register for tournament");
      }
    } catch (err) {
      console.error("Registration error:", err);
      notifyMessage("error", err.message, 5000, "colored", "top-center");
      return false;
    } finally {
      dispatch(setLoading(false));
    }
  };
};

// export const processPlayerRefund = (competitionId, playerId, reason) => {
//   return async (dispatch, getState) => {
//     dispatch(setLoading(true));
//     try {
//       const state = getState();
//       const token = state.user.tokens.jwtToken;

//       const response = await CompetitionServices.processRefund(competitionId, playerId, reason, token);

//       if (response.status === 200) {
//         notifyMessage("success", response.data.message || "Withdrawal successful.", 5000, "colored", "top-center");

//         await dispatch(fetchAllCompetitions());

//         return true;
//       } else {
//         throw new Error(response.data?.message || "Failed to process withdrawal and refund");
//       }
//     } catch (error) {
//       console.error("Refund error:", error);
//       notifyMessage(
//         "error",
//         error.message || "An error occurred while processing your withdrawal",
//         5000,
//         "colored",
//         "top-center"
//       );
//       return false;
//     } finally {
//       dispatch(setLoading(false));
//     }
//   };
// };

export const processPlayerRefund = (competitionId, playerId, reason) => {
  return async (dispatch, getState) => {
    dispatch(setLoading(true));
    try {
      const state = getState();
      const token = state.user.tokens.jwtToken;

      const response = await CompetitionServices.processRefund(competitionId, playerId, reason, token);

      if (response.status === 200) {
        const message =
          response.data.refundEligible === false
            ? "Withdrawal successful, but refund was denied because the withdrawal deadline has passed."
            : response.data.message || "Withdrawal successful.";

        notifyMessage("success", message, 5000, "colored", "top-center");

        await dispatch(fetchAllCompetitions());

        return true;
      } else {
        throw new Error(response.data?.message || "Failed to process withdrawal and refund");
      }
    } catch (error) {
      console.error("Refund error:", error);
      notifyMessage(
        "error",
        error.message || "An error occurred while processing your withdrawal",
        5000,
        "colored",
        "top-center",
      );
      return false;
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const processPayout = competitionId => {
  return async (dispatch, getState) => {
    dispatch(setLoading(true));
    try {
      const state = getState();
      const token = state.user.tokens.jwtToken;
      const response = await CompetitionServices.processTournamentPayout(competitionId, token);

      if (response.status === 200) {
        notifyMessage("success", "Tournament payout processed successfully!", 5000, "colored", "top-center");
        await dispatch(fetchAllCompetitions());
        return true;
      } else {
        throw new Error(response.data?.message || "Failed to process tournament payout");
      }
    } catch (err) {
      notifyMessage("error", err.message, 5000, "colored", "top-center");
      return false;
    } finally {
      dispatch(setLoading(false));
    }
  };
};

// async thunk for fetching all users from the database and saving it in the redux state
export const fetchAllUsers = () => {
  return async (dispatch, getState) => {
    try {
      const state = getState();
      const token = state.user.tokens.jwtToken;
      const response = await CompetitionServices.fetchUsers(token);
      if (response.status === 200) {
        // update state
        await dispatch(setAllUsers(response.data));
      } else if (response.status === 401) {
        const responseMessage = `Please Login Again! \n ${response.data.message ? response.data.message : ""}`;
        notifyMessage("error", responseMessage, 5000, "colored", "top-center");
        dispatch(logoutUser());
      } else {
        const errorMessage = `Failed to fetch Users! \n ${response.data.message ? response.data.message : ""}`;
        throw new Error(errorMessage);
      }
    } catch (error) {
      notifyMessage("error", error.message, 5000, "colored", "top-center");
    }
  };
};

export const fetchAllCompetitions = () => {
  return async (dispatch, getState) => {
    try {
      const token = getJWTToken(getState);
      const response = await CompetitionServices.getAllCompetitions(token);
      if (response.status === 200) {
        // update state
        await dispatch(setTournamentsAction(response.data));
      } else if (response.status === 401) {
        const responseMessage = `Please Login Again! \n ${response.data.message ? response.data.message : ""}`;
        notifyMessage("error", responseMessage, 5000, "colored", "top-center");
        dispatch(logoutUser());
      } else {
        const errorMessage = `Failed to fetch all competitions! \n ${
          response.data.message ? response.data.message : ""
        }`;
        throw new Error(errorMessage);
      }
    } catch (error) {
      notifyMessage("error", error.message, 5000, "colored", "top-center");
    }
  };
};

// GET CALL
export const fetchCompetitionByID = id => {
  return async (dispatch, getState) => {
    try {
      console.log("Inisde ..................fetchCompetitionByID", id);
      const token = getJWTToken(getState);
      const competitionId = id;
      console.log("Inisde ..................fetchCompetitionByID", competitionId);
      console.log("Inisde ..................fetchCompetitionByID", token);

      const response = await CompetitionServices.getCompetitionById(competitionId, token);
      if (response.status === 200) {
        const courseIds = response.data.courses.map(course => course.courseId);
        const coursesResponse = await CoursesServices.fetchCourseByIds(courseIds, token);
        if (coursesResponse.status === 200) {
          await dispatch(updateCourses(coursesResponse.data));
          await dispatch(setActiveTournamentAction(response.data));
          console.log("Updated Course Slice with Tournament course data");
          console.log("Updated Tournament Slice with Tournament data");
        } else if (coursesResponse.status === 401) {
          const responseMessage = `Please Login Again! \n ${response.data.message ? response.data.message : ""}`;
          notifyMessage("error", responseMessage, 5000, "colored", "top-center");
          dispatch(logoutUser());
        }
        // update state
      } else if (response.status === 401) {
        const responseMessage = `Please Login Again! \n ${response.data.message ? response.data.message : ""}`;
        notifyMessage("error", responseMessage, 5000, "colored", "top-center");
        dispatch(logoutUser());
      } else {
        const errorMessage = `Failed to fetch all competitions! \n ${
          response.data.message ? response.data.message : ""
        }`;
        throw new Error(errorMessage);
      }
    } catch (error) {
      notifyMessage("error", error.message, 5000, "colored", "top-center");
    }
  };
};

export const saveTeeSheet = (id, teeSheetData) => {
  return async (dispatch, getState) => {
    dispatch(setLoading(true));
    try {
      const state = getState();
      const token = state.user.tokens.jwtToken;
      const response = await CompetitionServices.saveTeeSheetInfo(id, teeSheetData, token);
      console.log("SaveTeeSheet Full Response:", response);
    } catch (err) {
      console.error("COMPLETE saveTeeSheet Error:", err);
      notifyMessage("error", err.message, 5000, "colored", "top-center");
      throw err;
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const fetchTeeSheet = competitionId => {
  return async (dispatch, getState) => {
    try {
      const token = getJWTToken(getState);
      const response = await CompetitionServices.getTeeSheet(competitionId, token);
      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error(`Failed to fetch tee sheet: ${response.data.message || ""}`);
      }
    } catch (error) {
      notifyMessage("error", error.message, 5000, "colored", "top-center");
      return null;
    }
  };
};

const formatToAMPM = time => {
  if (!time || time === "--:--") return "";
  if (time.includes("AM") || time.includes("PM")) {
    return time;
  }
  const [hours, minutes, seconds = "00"] = time.split(":").map(Number);
  const period = hours >= 12 ? "PM" : "AM";
  const formattedHours = hours % 12 || 12;
  return `${String(formattedHours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
    2,
    "0",
  )} ${period}`;
};

export const saveTournamentScores = (
  competitionId,
  playerId,
  roundId,
  scores,
  out,
  inTotal,
  totalScore,
  startTime,
  finishTime,
  totalTime,
  speedGolfScore,
) => {
  return async (dispatch, getState) => {
    dispatch(setLoading(true));
    try {
      const state = getState();
      const token = state.user.tokens.jwtToken;

      const scoreData = {
        playerId,
        roundId,
        scores,
        out,
        in: inTotal,
        totalScore,
        startTime,
        finishTime: finishTime.includes("AM") || finishTime.includes("PM") ? finishTime : formatToAMPM(finishTime), // Make sure it's in HH:mm:ss AM/PM format
        totalTime,
        speedGolfScore,
      };

      const response = await CompetitionServices.savePlayerScores(competitionId, scoreData, token);
      if (response.status === 200) {
        notifyMessage("success", "Scores saved successfully!", 5000, "colored", "top-center");
        return true;
      } else {
        throw new Error(response.data?.message || "Failed to save scores.");
      }
    } catch (error) {
      notifyMessage("error", error.message, 5000, "colored", "top-center");
      return false;
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const togglePublishStatus = (id, publishStatus, stripeAccountId = null) => {
  return async (dispatch, getState) => {
    dispatch(setLoading(true));
    try {
      const state = getState();
      const token = state.user.tokens.jwtToken;
      const response = await CompetitionServices.updatePublishStatus(id, publishStatus, stripeAccountId, token);

      if (response.status === 200) {
        notifyMessage(
          "success",
          `Tournament ${publishStatus ? "published" : "unpublished"} successfully!`,
          5000,
          "colored",
          "top-center",
        );
        // Refresh the tournaments list
        await dispatch(fetchAllCompetitions());
      } else {
        throw new Error(response.data?.message || "Failed to update tournament status");
      }
    } catch (err) {
      notifyMessage("error", err.message, 5000, "colored", "top-center");
    } finally {
      dispatch(setLoading(false));
    }
  };
};

export const fetchTeesets = () => {
  return async (dispatch, getState) => {
    try {
      const token = getJWTToken(getState);
      const response = await CompetitionServices.fetchAllTeesets(token);
      if (response.status === 200) {
        dispatch(setTeesets(response.data)); // Save teesets
      } else if (response.status === 401) {
        const responseMessage = `Please Login Again! \n ${response.data.message || ""}`;
        notifyMessage("error", responseMessage, 5000, "colored", "top-center");
        dispatch(logoutUser());
      } else {
        throw new Error(`Failed to fetch teesets! ${response.data.message || ""}`);
      }
    } catch (error) {
      notifyMessage("error", error.message, 5000, "colored", "top-center");
    }
  };
};

// export const searchCourses = (query) => {
//   return async (dispatch, getState) => {
//     dispatch(setLoading(true));
//     try {
//       const state = getState();
//       const token = state.user.tokens.jwtToken;
//       const response = await CoursesServices.searchCourses({searchString: query, category: "Name", limit: 1});
//       if (response.status === 200) {
//         return response.data;
//       }
//     } catch (error) {
//       notifyMessage("error", error.message, 5000, "colored", "top-center");
//     } finally {
//       dispatch(setLoading(false));
//     }
//   }
// }
